module.exports = "<span class=\"k-icon k-i-loading\" style=\"color: #3276b1\"></span>"